import { memo } from 'react';
import { useStore } from '@/store';
import { Image } from "@shuwen/wenlv-web-activity-library";
import { ThemeRoutePlaceInfo } from '@/store/types';
import { useSpring, animated } from '@react-spring/web';
import styles from './index.module.scss';

interface ThemeSpotProps {
  card: any;
  place: ThemeRoutePlaceInfo;
}

const poem = '步来禅榻畔，凉气逼团蒲。\n花雨檐前乱，茶烟竹下孤。\n乘闲携画卷，习静对香罏。\n到此忽终日，浮生一事无。';
const ThemeSpot = ({ place, card }: ThemeSpotProps) => {
  const setRouteTimeLineDetailId = useStore((state) => state.setRouteTimeLineDetailId);

  // const {
  //   timeLabel,
  //   time,
  //   workLabel,
  //   title,
  //   content
  // } = useMemo(() => {
  //   if (place?.content?.includes('\n')) {
  //     const arr = place.content.split('\n');
  //     return {
  //       timeLabel: '时间',
  //       time: arr[1],
  //       workLabel: '作品',
  //       title: arr[3],
  //       content: arr.slice(4).join('\n')
  //     }
  //   } else {
  //     return {
  //       timeLabel: '时间',
  //       time: '--',
  //       workLabel: '作品',
  //       title: '--',
  //       content: '--'
  //     }
  //   }
  // }, [place]);

  // const spring = useSpring({
  //   from: { scale: 0, opacity: 0 },
  //   to: { scale: 1, opacity: 1 },
  //   // delay: index * 50,
  //   config: {
  //     tension: 180 * 2,
  //     friction: 12,
  //   }
  // });

  return (
    <animated.div
      className={styles.themeSpot}
      // style={{
      //   left: place.left - 110,
      //   top: place.top - 40,
      //   // ...spring
      // }}
      onClick={() => {
        setRouteTimeLineDetailId(card.entity_id);
      }}
    >
      <div className={styles.topInfo}>
        <div className={styles.imgWrap}>
          <Image src={place?.image} className={styles.img} />
        </div>
        <div className={styles.title}>
          <div className={styles.name}>{place.name}</div>
          {/* <div className={styles.type}>{place?.type?.[0] || '--'}</div> */}
          {/* <div className={styles.type}>{place.biz_info?.tour_golden_sentences || '--'}</div> */}
          <div className={styles.type}>{place?.tour_golden_sentences || '--'}</div>
        </div>
      </div>
    </animated.div>
  );
};

export default memo(ThemeSpot); 